/*
 * @Author: your name
 * @Date: 2022-11-19 09:39:11
 * @LastEditTime: 2022-12-16 14:41:43
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/InductiveManage/DeployForm.tsx
 */
import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Form, Select, Input, Button, message } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form/Form';
import { singleBindApi, exportErrorExcelApi, exportBindApi } from 'root/services/nanotube';
import { exportExcelDownloadApi } from 'root/services/disk';
import { downloadFiles } from 'root/utils/utils';

import AddBtachFile from 'root/components/AddBtachFile';

import messages from './messages';
import styles from './index.less';

interface ITypeList {
  label: string;
  value: string;
}

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

interface IProps extends FormComponentProps {
  setCurrent: any;
  setImgSrc: any;
  imgSrc: string;
  changeCurrent: any;
}

const DeployForm = forwardRef<FormComponentProps, IProps>((props, ref) => {
  const intl = useIntl();
  const uploadFileRef = useRef<any>(null);
  const { form, setCurrent, setImgSrc, changeCurrent, imgSrc } = props;
  const { getFieldDecorator } = form;
  const typeList: ITypeList[] = [
    { label: intl.formatMessage(messages.deployAlone), value: 'alone' },
    { label: intl.formatMessage(messages.deployColoy), value: 'colony' },
  ];
  const [uploadStatus, setUploadStatus] = useState(true);

  useImperativeHandle(ref, () => ({
    form,
  }));

  // 自定义服务器地址校验
  const checkValue = async (rule: any, value: string, callback: () => void) => {
    if (!value) return callback();
    const flagIp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
    if (flagIp.test(value)) {
      return callback();
    } else {
      throw new Error(intl.formatMessage(messages.deployIPCheck));
    }
  };

  // 纳管
  const deployPost = () => {
    if (imgSrc === 'colony') {
      form.setFieldsValue({ fileList: uploadFileRef?.current.fileList });
    }
    form.validateFields((err: any, values: any) => {
      if (err) return;
      const { host, port, password, type } = values;

      // 单机纳管
      if (type === 'alone') {
        const params = {
          host,
          port,
          password,
        };
        singleBindApi(params).then(() => {
          setCurrent('deploying');
        });
      } else {
        // 集群纳管
        exportBindApi().then(() => {
          message.success('开始纳管');
          setCurrent('deploying');
        });
      }
    });
  };

  // 下载配置模板文件
  const handleDownloadFile = () => {
    exportExcelDownloadApi()
      .then((res) => {
        const { data } = res;
        downloadFiles(data, '集群配置模板.xlsx');
        message.success(intl.formatMessage(messages.downloadSuccess));
      })
      .catch(() => {
        message.error(intl.formatMessage(messages.downloadFail));
      });
  };

  // 文件上传失败时，下载失败提示文件
  const handleError = (path: string) => {
    exportErrorExcelApi(path)
      .then((res) => {
        const { data } = res;
        downloadFiles(data, '集群配置模板.xlsx');
        message.success(intl.formatMessage(messages.downloadSuccess));
      })
      .catch(() => {
        message.error(intl.formatMessage(messages.downloadFail));
      });
  };

  return (
    <Form {...formItemLayout} className={styles.deployForm}>
      <Form.Item label={intl.formatMessage(messages.deployType)}>
        {getFieldDecorator('type', {
          initialValue: 'alone',
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.deployTypeRequire),
            },
          ],
        })(
          <Select
            onSelect={(value: string) => {
              setImgSrc(value);
              setUploadStatus(true);
            }}
          >
            {typeList.map((item) => (
              <Option value={item.value} key={item.label}>
                {item.label}
              </Option>
            ))}
          </Select>,
        )}
      </Form.Item>

      {form.getFieldValue('type') === 'alone' ? (
        <>
          <Form.Item label={intl.formatMessage(messages.deployIP)}>
            {getFieldDecorator('host', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.deployIPRequire),
                },
                {
                  validator: checkValue,
                },
              ],
            })(<Input placeholder={intl.formatMessage(messages.deployIPRequire)} />)}
          </Form.Item>

          <Form.Item label={intl.formatMessage(messages.deploySSH)}>
            {getFieldDecorator('port', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.deploySSHRequire),
                },
                {
                  pattern: new RegExp(/^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))$/),
                  message: intl.formatMessage(messages.deploySSH),
                },
              ],
            })(<Input placeholder={intl.formatMessage(messages.deploySSHRequire)} />)}
          </Form.Item>

          <Form.Item label={intl.formatMessage(messages.deployUser)}>
            {getFieldDecorator('user', {
              initialValue: 'root',
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.deployUserRequire),
                },
              ],
            })(<Input disabled />)}
          </Form.Item>

          <Form.Item label={intl.formatMessage(messages.deployPwd)}>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.deployPwdRequire),
                },
              ],
            })(
              <Input.Password
                visibilityToggle={false}
                autoComplete="new-password"
                placeholder={intl.formatMessage(messages.deployPwdRequire)}
              />,
            )}
          </Form.Item>
        </>
      ) : (
        <Form.Item className={styles.uploadBatch} label={intl.formatMessage(messages.deployFile)}>
          {getFieldDecorator('fileList', {
            rules: [
              {
                required: true,
                message: intl.formatMessage(messages.deployFileRequire),
              },
            ],
          })(
            <AddBtachFile
              onDownload={handleDownloadFile}
              url="/api/ops-manager/v1/runtime_env/bind/excel/upload"
              onError={handleError}
              height={180}
              setUploadStatus={setUploadStatus}
              ref={uploadFileRef}
            />,
          )}
        </Form.Item>
      )}

      <Form.Item label={' '} colon={false}>
        <Button
          disabled={form.getFieldValue('type') === 'alone' ? !uploadStatus : uploadStatus}
          onClick={deployPost}
          type="primary"
        >
          {intl.formatMessage(messages.deployOk)}
        </Button>
        <Button onClick={() => changeCurrent('select')}>{intl.formatMessage(messages.deployCancel)}</Button>
      </Form.Item>
    </Form>
  );
});

export default Form.create()(DeployForm);
